module.exports = __webpack_public_path__ + "static/img/fc-3.35716aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduce/fc-3.png
// module id = P+jn
// module chunks = 0